<section *ngIf="saldosEnfermeras" class="card">
    <h2 style="text-align: center;">Saldo de Enfermeras</h2>

    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>
    <p-table [value]="paginacionSaldosEnfermeras" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Enfermera</th>
                <th>Puntos</th>
                <th>Redimir</th>
                <th>Saldo</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-enfermera>
            <tr>
                <td><a
                        [routerLink]="['/administrador/enfermera', enfermera.id_enfermera]">{{enfermera.nomEnfermera}}</a>
                </td>
                <td>{{enfermera.totales_puntos}}</td>
                <td>{{enfermera.totales_redimir_casosclinicos}}</td>
                <td>{{enfermera.totales_saldo}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage.first" [rows]="currentPage.rows"
            [totalRecords]="totalItems"></p-paginator>
    </div>
</section>